'use client';

export const StartAQuoteButton = ({ children, itemId }) => {
	return <div onClick={() => localStorage.setItem('leadInsuranceTypeId', itemId)}>
		{children}
	</div>;
}
